import React, { memo, forwardRef } from "react";
const SvgNumberzero = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M20.9 15.96c0 1.147-.113 2.18-.34 3.1-.213.92-.533 1.7-.96 2.34a4.351 4.351 0 01-1.56 1.48c-.613.347-1.32.52-2.12.52s-1.513-.173-2.14-.52a4.517 4.517 0 01-1.58-1.48c-.427-.64-.753-1.42-.98-2.34-.213-.92-.32-1.953-.32-3.1s.107-2.18.32-3.1c.227-.92.553-1.7.98-2.34a4.518 4.518 0 011.58-1.48c.627-.347 1.34-.52 2.14-.52s1.507.173 2.12.52c.627.347 1.147.84 1.56 1.48.427.64.747 1.42.96 2.34.227.92.34 1.953.34 3.1zm-2.46 0c0-.493-.033-1.053-.1-1.68a7.662 7.662 0 00-.36-1.78c-.173-.56-.427-1.027-.76-1.4-.333-.387-.767-.58-1.3-.58-.547 0-.987.193-1.32.58-.333.373-.593.84-.78 1.4a9.36 9.36 0 00-.36 1.78c-.067.627-.1 1.187-.1 1.68 0 .493.033 1.053.1 1.68s.187 1.213.36 1.76a4.19 4.19 0 00.78 1.4c.333.373.773.56 1.32.56.533 0 .967-.187 1.3-.56.333-.387.587-.853.76-1.4a7.355 7.355 0 00.36-1.76c.067-.627.1-1.187.1-1.68z"
      />
    </svg>
  );
});
SvgNumberzero.displayName = "SvgNumberzero";
const MemoForwardRef = memo(SvgNumberzero);
export default MemoForwardRef;
